import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {PlanSetting, PlanSettingParams} from '../plan-setting.model';

export enum PlanSettingActionTypes {
  LoadPlanSettings = '[PlanSetting] Load PlanSettings',
  AddPlanSetting = '[PlanSetting] Add PlanSetting',
  UpsertPlanSetting = '[PlanSetting] Upsert PlanSetting',
  AddPlanSettings = '[PlanSetting] Add PlanSettings',
  UpsertPlanSettings = '[PlanSetting] Upsert PlanSettings',
  UpdatePlanSetting = '[PlanSetting] Update PlanSetting',
  UpdatePlanSettings = '[PlanSetting] Update PlanSettings',
  DeletePlanSetting = '[PlanSetting] Delete PlanSetting',
  DeletePlanSettings = '[PlanSetting] Delete PlanSettings',
  ClearPlanSettings = '[PlanSetting] Clear PlanSettings',
  GetPlanSettings = '[PlanSetting] Get PlanSettings',
  GetUpdatePlanSettings = '[PlanSetting] Get Update PlanSettings',
  GetPlanSettingsFail = '[PlanSetting] Get PlanSettings Fail',
  ActivatePlanKey = '[PlanSetting] Activate Plan Key'
}

export class LoadPlanSettings implements Action {
  readonly type = PlanSettingActionTypes.LoadPlanSettings;

  constructor(public payload: { planSettings: PlanSetting[] }) {}
}

export class AddPlanSetting implements Action {
  readonly type = PlanSettingActionTypes.AddPlanSetting;

  constructor(public payload: { planSetting: PlanSetting }) {}
}

export class UpsertPlanSetting implements Action {
  readonly type = PlanSettingActionTypes.UpsertPlanSetting;

  constructor(public payload: { planSetting: PlanSetting }) {}
}

export class AddPlanSettings implements Action {
  readonly type = PlanSettingActionTypes.AddPlanSettings;

  constructor(public payload: { planSettings: PlanSetting[] }) {}
}

export class UpsertPlanSettings implements Action {
  readonly type = PlanSettingActionTypes.UpsertPlanSettings;

  constructor(public payload: { planSettings: PlanSetting[] }) {}
}

export class UpdatePlanSetting implements Action {
  readonly type = PlanSettingActionTypes.UpdatePlanSetting;

  constructor(public payload: { planSetting: Update<PlanSetting> }) {}
}

export class UpdatePlanSettings implements Action {
  readonly type = PlanSettingActionTypes.UpdatePlanSettings;

  constructor(public payload: { planSettings: Update<PlanSetting>[] }) {}
}

export class DeletePlanSetting implements Action {
  readonly type = PlanSettingActionTypes.DeletePlanSetting;

  constructor(public payload: { id: string }) {}
}

export class DeletePlanSettings implements Action {
  readonly type = PlanSettingActionTypes.DeletePlanSettings;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearPlanSettings implements Action {
  readonly type = PlanSettingActionTypes.ClearPlanSettings;
}

export class GetPlanSettings implements Action {
  readonly type = PlanSettingActionTypes.GetPlanSettings;
}

export class GetUpdatePlanSettings implements Action {
  readonly type = PlanSettingActionTypes.GetUpdatePlanSettings;
  constructor(public payload: PlanSettingParams) {}
}

export class GetPlanSettingsFail implements Action {
  readonly type = PlanSettingActionTypes.GetPlanSettingsFail;
}

export class ActivatePlanKey implements Action {
  readonly type = PlanSettingActionTypes.ActivatePlanKey;
  constructor(public payload: string) {}
}

export type PlanSettingActions =
 LoadPlanSettings
 | AddPlanSetting
 | UpsertPlanSetting
 | AddPlanSettings
 | UpsertPlanSettings
 | UpdatePlanSetting
 | UpdatePlanSettings
 | DeletePlanSetting
 | DeletePlanSettings
 | ClearPlanSettings
 | GetPlanSettings
 | GetUpdatePlanSettings
 | GetPlanSettingsFail
 | ActivatePlanKey;
